import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationGuard} from './authentication.guard';

@Component({
    template: '<h3>Redirecting...</h3>',
    standalone: false
})
export class OAuthCallbackComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthenticationGuard) {

  }
  ngOnInit(): void {
    console.log("Non-empty Constructor")
    }
}
